export const BOOKING_HISTORY_PATH = '/jetsetter/profile/booking-history';

export const isRouteCancelled = (flight) => {
  const status = String(flight?.status || '').toLowerCase();
  return status === 'canceled' || status === 'cancelled';
};

export const collectFlightsFromPaymentState = ({
  flightData,
  returnFlightData,
  multiCityFlights,
  bookingData,
}) => {
  const flights = [];

  if (multiCityFlights?.length) {
    flights.push(...multiCityFlights);
  } else if (returnFlightData) {
    if (flightData) flights.push(flightData);
    flights.push(returnFlightData);
  } else if (flightData) {
    flights.push(flightData);
  } else if (bookingData?.selectedFlights?.length) {
    flights.push(...bookingData.selectedFlights);
  }

  return flights;
};

export const findCancelledFlights = (flights) =>
  (flights || []).filter(isRouteCancelled);

export const buildCancelledFlightMessage = (cancelledFlights) => {
  const names = (cancelledFlights || [])
    .map((f) => f.flight_number)
    .filter(Boolean)
    .join(', ');

  if (names) {
    return `Flight${cancelledFlights.length > 1 ? 's' : ''} ${names} ${
      cancelledFlights.length > 1 ? 'have' : 'has'
    } been cancelled and is no longer available.`;
  }

  return 'This flight has been cancelled and is no longer available.';
};

export const isFlightCancelledApiResponse = (response) =>
  response?.code === 'flight_cancelled' ||
  response?.data?.code === 'flight_cancelled';
